import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import {
  PlusCircle,
  RotateCcw,
  ChevronUp,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import {
  deletePurchase,
  getPurchaseByTransType,
} from "../../../services/PurchaseApiService";
import GoodsReceiptModal from "../../../components/transactions/modal/GoodsReceiptModal";
import { OverlayTrigger, TabPane, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setheadertoggle } from "../../../redux/toggle";
import { PurchaseClass } from "../../../core/json/Purchase";
import dayjs from "dayjs";
import { renderTooltip } from "../../../redux/helper";
import { getJSON } from "jquery";
import { DatePicker, Select, Tabs } from "antd";
import {
  // fetchUnit,
  // fetchProduct,
  // fetchTax,
  fetchSupplier,
  // fetchSettings,
} from "../../../redux/userSetting";
import {
  printReport,
  exportExcel,
  exportPDF,
} from "../../../core/utils/reportUtils";
import { fetchBranchSettings } from "../../../redux/settingbyBranch";
import Datatable from "../../../core/pagination/datatable";

const GoodsReceiptReport = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [purchaseData, setPurchaseData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  //
    const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemwiseData, setitemwiseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filtereditemData, setFiltereditemData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { formatedproductList, formatedsupplierList } = useSelector(
    (state) => state.usersetting
  );
  const { menuItems } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const { branch } = useSelector((state) => state.branchlist);
  const { TabPane } = Tabs;

 
  
  const { userId } = useSelector((state) => state.userauth);

  const dispatch = useDispatch();

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  useEffect(() => {
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Goods Receipt")
    );
    dispatch(fetchSupplier());
      dispatch(fetchUnit());
            dispatch(fetchProduct(branch));
            dispatch(fetchTax());
            dispatch(fetchSettings(branch));
        
  }, []);
  useEffect(() => {
    handlePurchaseData();
    dispatch(fetchBranchSettings(branch.guid));
  }, [branch]);
  const currfmt = useSelector((state) => {
    const match = state.usersetting?.settingList?.currencyFormat?.toString()?.match(/\.0+/);
    return match ? match[0]?.length - 1 : 0;
  });
  // Fetch goods receipt data
  const handlePurchaseData = async () => {
    try {
      const response = await getPurchaseByTransType(branch, 1);
      const invoice = Array.isArray(response.data) ? response.data : [];
      setPurchaseData(invoice);
      setFilteredData(invoice);
      let serialCounter = 1;
      const itemwiseData = (invoice) => {
        return invoice.purchaseDetails?.map((item, index) => {
          return {
            key: serialCounter,
            slno: serialCounter++,
            date: invoice.date,
            entrynumber: invoice.entrynumber,
            supplier: invoice.supplier?.name || "Unknown Supplier",
            supplierid: invoice.supplier?.guid || "Unknown Supplier",
            itemName: item.product?.name || "Unknown Item",
            itemid: item.product?.guid || "Unknown Item",
            quantity: item.quantity,
            rate: item.price.toFixed(currfmt),
            total: item.netAmount.toFixed(currfmt),
            discountTotal: item.discountAmount.toFixed(currfmt),
            tax: item.taxAmount.toFixed(currfmt),
            netAmount: invoice.netTotal.toFixed(currfmt),
            purchasePaymentType: invoice.purchasePaymentType,
          };
        });
      };

      const allItemwiseData = invoice.flatMap((invoice) =>
        itemwiseData(invoice)
      );
      setitemwiseData(allItemwiseData);
      setFiltereditemData(allItemwiseData);
    } catch (error) {
      console.error(
        "Failed to fetch goods receipt",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  useEffect(() => {
    handleFilter();
  }, [searchText, purchaseData]);
  const paymentType = {
    0: "Cash",
    1: "Card",
    2: "Bank",
    3: "Credit",
    4: "UPI",
  };
  function handleFilter() {
    // console.log("Original purchaseData:", purchaseData);
    // console.log("Search Text:", searchText);
    // console.log("From Date:", fromDate, "To Date:", toDate);
    // console.log("Selected Product:", selectedProduct);
    // console.log("Selected Supplier:", selectedSupplier);

    const filteredData = purchaseData?.filter((entry) => {
      // console.log("Current Entry:", entry);
      const supplierMatch =
        !selectedSupplier || entry.supplier?.guid === selectedSupplier;
      const productMatch =
        !selectedProduct ||
        entry?.purchaseDetails?.some(
          (detail) => detail?.product?.guid === selectedProduct
        );
      const fromDateMatch =
        !fromDate || new Date(entry.date) >= new Date(fromDate);
      const toDateMatch = !toDate || new Date(entry.date) <= new Date(toDate);

      const searchTextMatch =
        entry?.date?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.supplier?.name
          ?.toLowerCase()
          .includes(searchText?.toLowerCase()) ||
        entry?.invoiceDate?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.referenceNumber
          ?.toLowerCase()
          .includes(searchText?.toLowerCase()) ||
        (paymentType[entry?.purchasePaymentType]?.toLowerCase() || "").includes(
          searchText?.toLowerCase()
        ) ||
        entry?.entrynumber?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.netTotal?.toString().includes(searchText);

      return (
        supplierMatch &&
        productMatch &&
        fromDateMatch &&
        toDateMatch &&
        searchTextMatch
      );
    });

    setFilteredData(filteredData);
    handleFilteritem();
  }
  function handleFilteritem() {
    const filteredData = itemwiseData?.filter((entry) => {
      //console.log("Current Entry:", entry);
      const supplierMatch =
        !selectedSupplier || entry.supplierid === selectedSupplier;
      const productMatch = !selectedProduct || entry.itemid === selectedProduct;
      const fromDateMatch =
        !fromDate || new Date(entry.date) >= new Date(fromDate);
      const toDateMatch = !toDate || new Date(entry.date) <= new Date(toDate);

      const searchTextMatch =
        entry?.date?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.supplier?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.itemName?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.date?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.referenceNumber
          ?.toLowerCase()
          .includes(searchText?.toLowerCase()) ||
        (paymentType[entry?.purchasePaymentType]?.toLowerCase() || "").includes(
          searchText?.toLowerCase()
        ) ||
        entry?.entrynumber?.toLowerCase().includes(searchText?.toLowerCase()) ||
        entry?.quantity?.toString().includes(searchText) ||
        entry?.rate?.toString().includes(searchText) ||
        entry?.netAmount?.toString().includes(searchText) ||
        entry?.tax?.toString().includes(searchText) ||
        entry?.discountTotal?.toString().includes(searchText) ||
        entry?.total?.toString().includes(searchText);

      return (
        supplierMatch &&
        productMatch &&
        fromDateMatch &&
        toDateMatch &&
        searchTextMatch
      );
    });

    setFiltereditemData(filteredData);
  }

     const renderSummaryRow = (totals, columns) => (
          <Datatable.Summary.Row>
            {columns.map((col, idx) => {
              if (idx === 0) {
                return (
                  <Datatable.Summary.Cell key="label">
                    <b>Total</b>
                  </Datatable.Summary.Cell>
                );
              }
              if (totals[col.dataIndex] !== undefined) {
                return (
                  <Datatable.Summary.Cell key={col.dataIndex}>
                    <b>{Number(totals[col.dataIndex]).toFixed(2)}</b>
                  </Datatable.Summary.Cell>
                );
              }
              return <Datatable.Summary.Cell key={col.dataIndex} />;
            })}
          </Datatable.Summary.Row>
        );
  

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Number",
      dataIndex: "entrynumber",
     // sorter: (a, b) => a.entrynumber.localeCompare(b.entrynumber),
      sorter: (a, b) => a.entrynumber.localeCompare(b.entrynumber, undefined, { numeric: true, sensitivity: 'base' }),
    },
    {
      title: "Supplier",
      dataIndex: "supplier.name",
      sorter: (a, b) => a.supplier?.name?.length - b.supplier?.name?.length,
      render: (_, record) => record?.supplier?.name,
    },
    {
      title: "GRN No",
      dataIndex: "invoiceNo",
      sorter: (a, b) => a.invoiceNo - b.invoiceNo,
    },
    {
      title: "Delivery Date",
      dataIndex: "duedate",
      sorter: (a, b) => (dayjs(a.duedate).isAfter(dayjs(b.duedate)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Status",
      dataIndex: "purchasePaymentType",
      render: (purchasePaymentType) => {
        let badgeClass = "";
        let text = "";

        switch (purchasePaymentType) {
          case 0:
            text = "Cash";
            badgeClass = "bg-lightyellow";
            break;
          case 1:
            text = "Card";
            badgeClass = "bg-lightpurple";
            break;
          case 2:
            text = "Bank";
            badgeClass = "bg-lightblue";
            break;
          case 3:
            text = "Credit";
            badgeClass = "bg-lightred";
            break;
          case 4:
            text = "UPI";
            badgeClass = "bg-lightgreen";
            break;
          default:
            text = "Unknown";
            badgeClass = "";
        }

        return <span className={`badges ${badgeClass}`}>{text}</span>;
      },
      sorter: (a, b) => a.purchasePaymentType - b.purchasePaymentType,
    },
    {
      title: "Net Amount",
      dataIndex: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
    },
    ...(permit?.edit || permit?.deletion
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, obj) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {permit?.edit && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      onClick={() => handleEditClick(obj.guid)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permit?.deletion && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => handleDeleteClick(obj)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : []),
  ];
  const Reportcolumns = [
    {
      title: "Sl No.",
      dataIndex: "no",

      render: (text, record, index) => index + 1,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Bill No",
      dataIndex: "entrynumber",
      sorter: (a, b) => a.entrynumber.localeCompare(b.entrynumber),
    },
    {
      title: "Supplier",
      dataIndex: "supplier.name",
      sorter: (a, b) => a.supplier?.name?.length - b.supplier?.name?.length,
      render: (_, record) => record?.supplier?.name,
    },
    {
      title: "Total",
      dataIndex: "grossTotal",
      sorter: (a, b) => a.grossTotal - b.grossTotal,
    },
    {
      title: "Discount",
      dataIndex: "discountTotal",
      sorter: (a, b) => a.discountTotal - b.discountTotal,
    },
    {
      title: "Tax",
      dataIndex: "taxTotal",
      sorter: (a, b) => a.taxTotal - b.taxTotal,
    },
    {
      title: "Net",
      dataIndex: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
    },
  ];
  const supplierColumns = [
    {
      title: "Sl No.",
      dataIndex: "no",

      render: (text, record, index) => index + 1,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Bill No",
      dataIndex: "entrynumber",
      sorter: (a, b) => a.entrynumber.localeCompare(b.entrynumber),
    },
    {
      title: "Supplier",
      dataIndex: "supplier.name",
      sorter: (a, b) => a.supplier?.name?.length - b.supplier?.name?.length,
      render: (_, record) => record?.supplier?.name,
    },
    {
      title: "GRN No.",
      dataIndex: "invoiceNo",
      sorter: (a, b) => a.invoiceNo?.length - b.invoiceNo?.length,
    },
    {
      title: "GRN Date",
      dataIndex: "invoiceDate",
      sorter: (a, b) =>
        dayjs(a.invoiceDate).isAfter(dayjs(b.invoiceDate)) ? 1 : -1,
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Total",
      dataIndex: "grossTotal",
      sorter: (a, b) => a.grossTotal - b.grossTotal,
    },
    {
      title: "Discount",
      dataIndex: "discountTotal",
      sorter: (a, b) => a.discountTotal - b.discountTotal,
    },
    {
      title: "Tax",
      dataIndex: "taxTotal",
      sorter: (a, b) => a.taxTotal - b.taxTotal,
    },
    {
      title: "Net",
      dataIndex: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
    },
  ];

  const Itemwisecolumns = [
    {
      title: "Sl No.",
      dataIndex: "slno",
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1),
      render: (date) => dayjs(date).format("DD-MM-YY"),
    },
    {
      title: "Bill No",
      dataIndex: "entrynumber",
      sorter: (a, b) => a.entrynumber.localeCompare(b.entrynumber),
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      sorter: (a, b) => a.supplier?.length - b.supplier?.length,
    },
    {
      title: "Item Name",
      dataIndex: "itemName",
      sorter: (a, b) => a.itemName?.length - b.itemName?.length,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Rate",
      dataIndex: "rate",
      sorter: (a, b) => a.rate - b.rate,
    },

    {
      title: "Discount",
      dataIndex: "discountTotal",
      sorter: (a, b) => a.discountTotal - b.discountTotal,
    },
    {
      title: "Tax",
      dataIndex: "tax",
      sorter: (a, b) => a.tax - b.tax,
    },
    {
      title: "Total",
      dataIndex: "total",
      sorter: (a, b) => a.total - b.total,
    },
    {
      title: "Net",
      dataIndex: "netAmount",
      sorter: (a, b) => a.netAmount - b.netAmount,
    },
  ];

        const footerTotals = {
    netTotal: filteredData?.reduce((sum, record) => sum + (Number(record.netTotal) || 0), 0) || 0,
    grossTotal: filteredData?.reduce((sum, record) => sum + (Number(record.grossTotal) || 0), 0) || 0,
    discountTotal: filteredData?.reduce((sum, record) => sum + (Number(record.discountTotal) || 0), 0) || 0,
    taxTotal: filteredData?.reduce((sum, record) => sum + (Number(record.taxTotal) || 0), 0) || 0,
  };

    const itemwiseTotals = {
    total: filtereditemData?.reduce((sum, r) => sum + (Number(r.total) || 0), 0) || 0,
    discountTotal: filtereditemData?.reduce((sum, r) => sum + (Number(r.discountTotal) || 0), 0) || 0,
    tax: filtereditemData?.reduce((sum, r) => sum + (Number(r.tax) || 0), 0) || 0,
    netAmount: filtereditemData?.reduce((sum, r) => sum + (Number(r.netAmount) || 0), 0) || 0,
    quantity: filtereditemData?.reduce((sum, r) => sum + (Number(r.quantity) || 0), 0) || 0,
    rate: filtereditemData?.reduce((sum, r) => sum + (Number(r.rate) || 0), 0) || 0,
  };

  const MySwal = withReactContent(Swal);

  // Handle the click event to delete a goods receipts
  const handleDeleteClick = (obj) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const objPurchase = new PurchaseClass();
          objPurchase.id = obj.id;
          objPurchase.guid = obj.guid;
          objPurchase.branch = branch;
          objPurchase.isDeleted = true;
          objPurchase.updatedUser = `{${userId?.id}}`; //"";
          const response = await deletePurchase(objPurchase);
          if (response) {
            MySwal.fire({
              title: "Deleted!",
              text: "The Goods Receipt has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handlePurchaseData(); // Refresh the list
              setSearchText(""); // Clear the search text
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error(
            "Failed to fetch goods reciept",
            error?.response?.data?.Message || "something went wrong"
          );
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const handleEditClick = async (guid) => {
    try {
      const response = getPurchaseInvoiceByGuid(guid);

      setUpdateData(response);
      setModalMode("edit");
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error fetching goods receipt by GUID",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  function getPurchaseInvoiceByGuid(guid) {
    const filteredPurchase = purchaseData?.filter(
      (purchase) => purchase.guid === guid
    );

    return filteredPurchase[0];
  }
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create a column mapping (column title to dataIndex)
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map column title to its dataIndex
      });
      return mappings;
    };
    switch (activeTab) {
      case "1":
        fieldMapping = createfieldMapping(columns);

        return {
          data: filteredData,
          columns: columns,
          fieldMapping,
          filename: "Goods Receipt",
          totals: footerTotals,
        };
      case "2":
        fieldMapping = createfieldMapping(Reportcolumns);

        return {
          data: filteredData,
          columns: Reportcolumns,
          fieldMapping,
          filename: "Goods Receipt Detailed Report",
          totals: footerTotals,
        };
      case "3":
        fieldMapping = createfieldMapping(supplierColumns);

        return {
          data: filteredData,
          columns: supplierColumns,
          fieldMapping,
          filename: "Goods Receipt Supplier Report",
          totals: footerTotals,
        };
      case "4":
        fieldMapping = createfieldMapping(Itemwisecolumns);

        return {
          data: filtereditemData,
          columns: Itemwisecolumns,
          fieldMapping,
          filename: "Goods Receipt Itemwise Report",
          totals:itemwiseTotals
        };
      default:
        return { data: [], columns: [], filename: [] };
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    setToDate(null);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);
  };
  function handleReset() {
    setFromDate(null);
    setToDate(null);
    setSelectedProduct(null);
    setSelectedSupplier(null);
    setSearchText("");
    setFilteredData(purchaseData);
    setFiltereditemData(itemwiseData);
  }
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Goods Receipt Report</h4>
                <h6>Manage goods receipt reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() => exportPDF(getActiveTabData, "GoodsReceipt")}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportExcel(getActiveTabData, "GoodsReceipt")
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printReport(getActiveTabData, "GoodsReceipt")
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handlePurchaseData()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
         
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              {/* <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      aria-controls="DataTables_Table_0"
                      value={searchText}
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset btn-sm rounded-2">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div> */}
              {/* 
                <div className="d-flex justify-content-end">
                  {/* {isFilterVisible && ( */}
              {/* <div className="input-blocks me-2">
                    <button
                      className="btn btn-filters  h-100 rounded-2"
                      onClick={() => {
                        handleFilter();
                        handleFilteritem();
                      }}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search
                    </button>
                  </div>
                  {/* )} */}

              {/* <div className="input-blocks">
                    <button
                      className="btn btn-reset  rounded-2 "
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div> */}
              {/* </div>
              </div>  */}

              {/* <div
                className={`${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              > */}
              {/* <div className="card-body">
                <div className="row">
                  {/* From Date Filter */}
              {/* <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks ms-4">
                      <label>From Date</label>
                      <div className="input-groupicon ">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          dateFormat="dd/MM/yyyy"
                          style={{ height: "38px", width: "100%" }} // Inline styles for height and width
                        />
                      </div>
                    </div>
                  </div>  */}

              {/* To Date Filter */}
              {/* <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks ">
                      <label>To Date</label>
                      <div className="input-groupicon ">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate}
                          dateFormat="dd/MM/yyyy"
                          style={{ height: "38px", width: "100%" }} // Inline styles for height and width
                        />
                      </div>
                    </div>
                  </div> */}
              {/* <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label>Product</label>

                      <div className="input-groupicon ">
                        <Select
                          className="img-select"
                          options={formatedproductList}
                          value={selectedProduct}
                          onChange={handleProductChange}
                          classNamePrefix="react-select"
                          placeholder="Products"
                          style={{ height: "38px", width: "100%" }}
                        />
                      </div>
                    </div>
                  </div> */}
              {/* <div className="col-lg-2 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label>Supplier</label>

                      <div className="input-groupicon ">
                        <Select
                          className="img-select"
                          options={formatedsupplierList}
                          value={selectedSupplier}
                          onChange={handleSupplierChange}
                          classNamePrefix="react-select"
                          placeholder="Suppliers"
                          style={{ height: "38px", width: "100%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="row align-items-center m-1">
                {/* Search Input */}
                <div className="col-auto mt-3">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm "
                    value={searchText}
                    onChange={handleSearch}
                    style={{ height: "38px", width: "100%" }}
                  />
                </div>

                {/* From Date */}
                <div className="col-auto mt-3">
                  <div className="input-blocks ms-4">
                    <label>From Date</label>
                    <div className="input-groupicon ">
                      <Calendar className="info-img" />
                      <DatePicker
                        className="datetimepicker"
                        id="from-date"
                        placeholderText="From Date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        startDate={fromDate}
                        selectsStart
                        dateFormat="dd/MM/yyyy"
                        style={{ height: "38px", width: "100%" }} // Inline styles for height and width
                      />
                    </div>
                  </div>
                </div>

                {/* To Date */}
                <div className="col-auto mt-3">
                  <div className="input-blocks">
                    <label>To Date</label>
                    <div className="input-groupicon ">
                      <Calendar className="info-img" />
                      <DatePicker
                        id="to-date"
                        placeholderText="To Date"
                        value={toDate}
                        onChange={handleToDateChange}
                        minDate={fromDate}
                        startDate={fromDate}
                        selectsEnd
                        disabled={!fromDate}
                        dateFormat="dd/MM/yyyy"
                        style={{ height: "38px", width: "100%" }} // Inline styles for height and width
                      />
                    </div>
                  </div>
                </div>

                {/* Product Dropdown */}
                <div className="col-auto mt-3">
                  <div className="input-blocks">
                    <label>Product</label>

                    <div className="input-groupicon ">
                      <Select
                        className="img-select"
                        options={formatedproductList}
                        value={selectedProduct}
                        onChange={handleProductChange}
                        classNamePrefix="react-select"
                        placeholder="Products"
                        style={{ height: "38px", width: "100%" }}
                      />
                    </div>
                  </div>
                </div>

                {/* Supplier Dropdown */}
                <div className="col-auto mt-3">
                  <div className="input-blocks">
                    <label>Supplier</label>

                    <div className="input-groupicon ">
                      <Select
                        className="img-select"
                        options={formatedsupplierList}
                        value={selectedSupplier}
                        onChange={handleSupplierChange}
                        classNamePrefix="react-select"
                        placeholder="Suppliers"
                        style={{ height: "38px", width: "100%" }}
                      />
                    </div>
                  </div>
                </div>

                {/* Search Button */}
                <div className="col-auto mt-3">
                  <button className="btn btn-primary" onClick={handleFilter}>
                    Search
                  </button>
                </div>

                {/* Reset Button */}
                <div className="col-auto mt-3">
                  <button className="btn btn-secondary" onClick={handleReset}>
                    Reset
                  </button>
                </div>
              </div>

              {/* </div> */}
              <div className="table-responsive">
                <Tabs defaultActiveKey="1" onChange={handleTabChange}>
               
                  <TabPane tab="Detailed Reports" key="2">
                    <Table columns={Reportcolumns} dataSource={filteredData} 
                                                 summary={() => renderSummaryRow(footerTotals, Reportcolumns)}
                                         pagination={{
    current: currentPage,
    pageSize,
    total: filteredData.length, // or API response total
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  }}/>
                  </TabPane>
                  <TabPane tab="Supplier Reports" key="3">
                    <Table
                      columns={supplierColumns}
                      dataSource={filteredData}
                                                   summary={() => renderSummaryRow(footerTotals, supplierColumns)}
                                         pagination={{
    current: currentPage,
    pageSize,
    total: filteredData.length, // or API response total
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  }}
                    />
                  </TabPane>
                  <TabPane tab="Itemwise Reports" key="4">
                    <Table
                      columns={Itemwisecolumns}
                      dataSource={filtereditemData}
                                                   summary={() => renderSummaryRow(itemwiseTotals, Itemwisecolumns)}
                                         pagination={{
    current: currentPage,
    pageSize,
    total: filteredData.length, // or API response total
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  }}
                    />
                  </TabPane>
                </Tabs>
                {/* <Table columns={columns} dataSource={filteredData} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Reason Modal */}
      {modalOpen && (
        <GoodsReceiptModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handlePurchaseData(); // Refresh the list
            setSearchText(""); // Clear the search text
          }}
        />
      )}
    </div>
  );
};

export default GoodsReceiptReport;
